<template>
  <div class="page-home">
    <Highlight/>
    <div class="row">
   <div class="col-md-12 blog-main">
      <div class="blog-post">
         <h2 class="blog-post-title">KRITERIA PENERIMA BANTUAN</h2>
         <div class="col-md-12 highlight">
            Program subsidi bunga/subsidi margin ini ditujukan bagi UMKM yang memiliki pinjaman produktif dengan plafon maksimal Rp.10 Miliar.
         </div>
         
         <p>Subsidi UMKM program Pemulihan Ekonomi Nasional (PEN) ditujukan bagi UMKM yang memenuhi kriteria sebagai berikut:</p>
         <ul>
            <li>Memiliki baki debet Kredit/Pembiayaan aktif per 29 Februari 2020</li>
            <li>Tidak termasuk dalam Daftar Hitam Nasional
            <li>Memiliki kategori <i>performing loan</i> lancar dengan kolektibilitas 1 atau 2 per 29 Februari 2020
            <li>Memiliki NPWP atau mendaftar untuk mendapatkan NPWP
            <li>Harus memperoleh restrukturisasi dari Penyalur Kredit/Pembiayaan untuk Debitur memiliki plafon Kredit/Pembiayaan kumulatif di atas Rp.500.000.000 (lima ratus juta rupiah) sampai dengan Rp.10.000.000.000 (sepuluh miliar rupiah)
            <li>Debitur Koperasi selain kriteria sebagaimana di atas, Debitur harus memenuhi kriteria yang diatur oleh Kementerian Koperasi dan Usaha Kecil dan Menengah</li>
         </ul>
         <div class="Container-content">
            <h2 class="subtitle-covid">KETENTUAN UMUM WAKTU DAN BESARAN BANTUAN SUBSIDI UMKM PROGRAM PEN</h2>
            <div class="col-md-12 highlight">
            Subsidi UMKM program PEN diberikan dalam bentuk subsidi bunga/subsidi margin Kredit/Pembiayaan yang berlaku selama periode waktu paling lama 6 (enam) bulan yang berlaku sejak tanggal 1 Mei 2020.
            </div>

            <p>Untuk Kredit/Pembiayaan dari Perbankan dan Perusahaan Pembiayaan, maka besaran subsidi yang diterima adalah:</p>
            <ul>
               <li>Pinjaman dengan akumulasi plafon sampai dengan Rp.500 Juta, subsidi bunga/subsidi margin 6% untuk 3 bulan pertama, 3% untuk 3 bulan kedua</li>
               <li> Pinjaman dengan akumulasi plafon di atas Rp.500 Juta s.d. Rp.10 Miliar, subsidi bunga/subsidi margin 3% untuk 3 bulan pertama, 2% untuk 3 bulan kedua</li>
            </ul>
            <p>Untuk Kredit/Pembiayaan dari Lembaga Penyalur Kredit Program Pemerintah:</p>
            <ul>
               <li>Pinjaman sampai dengan Rp.10 Juta subsidi sebesar beban bunga/margin Debitur, paling tinggi 25%</li>
               <li>Pinjaman dengan akumulasi di atas Rp.10 Juta s.d. Rp.500 Juta, subsidi bunga/subsidi margin 6% untuk 3 bulan pertama, 3% untuk 3 bulan kedua</li>
               <li>Pinjaman dengan akumulasi di atas Rp.500 Juta s.d. Rp.10 Miliar, subsidi bunga/subsidi margin 3% untuk 3 bulan pertama, 2% untuk 3 bulan kedua</li>
            </ul>
            <p>Jumlah akad pinjaman yang diberikan subsidi, berlaku sesuai ketentuan berikut:</p>
            <ul>
               <li>Debitur dengan akad pinjaman kumulatif sampai dengan Rp.500 Juta, maksimal 2 akad yang mendapat subsidi bunga/subsidi margin</li>
               <li>Debitur dengan akad pinjaman kumulatif Rp.500 Juta s.d. Rp.10 Miliar, maksimal 1 akad yang mendapat subsidi bunga/subsidi margin</li>
            </ul>
         </div>
         <div class="Container-content">
            <h2 class="subtitle-covid">ALUR INFORMASI DEBITUR</h2>
            <p class="mt-20">Jika Anda merupakan pelaku UMKM dan telah memenuhi syarat di atas, maka data Anda akan
            secara otomatis masuk ke dalam data yang disampaikan oleh OJK ke Kementerian Keuangan untuk
            diproses untuk mendapatkan subsidi bunga/subsidi margin program PEN. Secara lebih lanjut, Anda dapat
            menghubungi Penyalur Kredit/Pembiayaan Anda untuk mendapatkan informasi terkait pinjaman
            Anda. </p>
            <p>Lebih lanjut jika Anda telah terdaftar, maka Anda akan mendapatkan pemberitahuan dari Bank,
            Perusahaan Pembiayaan atau Lembaga Penyalur Program Kredit Pemerintah untuk melakukan
            pengecekan informasi terkait dengan besaran subsidi bunga/subsidi margin yang Anda dapatkan.</p>
            <p>Segera konfirmasi ke Bank, Perusahaan Pembiayaan atau Lembaga Penyalur Program Kredit
            Pemerintah Anda, jika Anda merasa telah sesuai kriteria namun tidak mendapatkan pemberitahuan
            untuk melakukan pengecekan subsidi bunga/subsidi margin yang diterima.</p>
            <p>Anda dapat melakukan pengecekan secara mandiri atau dengan pendampingan dari pihak lain.</p>

            <p>Jika Anda telah menerima pemberitahuan, segera lakukan proses pengecekan melalui laman <a href="/subsidi" class="link-call">Cek Subsidi</a></p>
            <div class="container-button">
               <a href="/subsidi" @click="GAEventTrack('body', 'click-button', 'cek-subsidi')" role="button" aria-pressed="true" class="btn btn-primary button-form">Cek Subsidi</a>
            </div>
         </div>
         <!-- <div class="Container-content">
            <h2 class="subtitle-covid">Alur Pendaftaran</h2>
            <p class="mt-20">Apabila telah memenuhi kriteria di atas, calon penerima bantuan wajib melengkapi formulir pendaftaran.
            </p>
            <ol>
               <li>Mengisi formulir pendaftaran dengan lengkap dan benar. Formulir pendaftaran dapat diakses pada laman formulir pendaftaran</li>
               <li>Menerima konfirmasi, dalam bentuk SMS, terkait penerimaan insentif dimana Pelaku Usaha akan diberikan kode pengambilan dana untuk kemudian dicairkan melalui agen Laku Pandai (agen BNI46, agen BRI Link, Agen Mandiri) atau ATM Bank Himbara (BNI, BRI, Mandiri, BTN)</li>
               <li>Apabila Pelaku Usaha terverifikasi untuk mendapat bantuan subsidi pembayaran angsuran kredit, maka Lembaga Keuangan Penyalur Pembiayaan akan memberikan informasi/notifikasi kepada Pelaku Usaha</li>
            </ol>
            <div class="container-button">
               <a href="/masuk" role="button" aria-pressed="true" class="btn btn-primary button-form">Cek Subsidi</a>
            </div>
         </div> -->
         <div class="Container-content">
            <h2 class="subtitle-covid mb-4">TANYA JAWAB PROGRAM</h2>

            <div class="accordion" id="accordion-faq">
               <div class="card mb-2">
                  <div class="card-header" id="headin-1">
                     <h2 class="mb-0">
                     <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse-1" aria-expanded="falsee" aria-controls="collapse-1">
                        1.	Adakah batasan maksimum periode (tenor) pinjaman yang Pelaku Usaha daftarkan?
                        <span class="icon-trigger float-right"><i class="fa fa-chevron-down"></i></span>
                     </button>
                     </h2>
                  </div>

                  <div id="collapse-1" class="collapse" aria-labelledby="headin-1" data-parent="#accordion-faq">
                     <div class="card-body">
                     <i>Tidak ada, namun akad pinjaman Anda harus sekurang-kurangnya masih memiliki outstanding aktif dengan status kolektibilitas lancar per tanggal 29 Februari 2020.</i>
                     </div>
                  </div>
               </div>
               <div class="card mb-2">
                  <div class="card-header" id="headin-2">
                     <h2 class="mb-0">
                     <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse-2" aria-expanded="false" aria-controls="collapse-2">
                        2.	Bagaimana jika Pelaku Usaha menerima konfirmasi penerimaan bantuan, tapi masih ditagihkan pembayaran bunga/margin pinjaman oleh pihak pemberi pinjaman terkait?
                     <span class="icon-trigger float-right"><i class="fa fa-chevron-down"></i></span>
                     </button>
                     </h2>
                  </div>

                  <div id="collapse-2" class="collapse" aria-labelledby="headin-2" data-parent="#accordion-faq">
                     <div class="card-body">
                     <p><i>Perlu diperhatikan bahwa subsidi bunga/subsidi margin bisa saja tidak memenuhi seluruh beban bunga/margin yang ditanggung oleh debitur, maka ada kemungkinan Anda masih akan menanggung selisih dari besaran antara bunga/margin yang dikenakan dan subsidi bunga/subsidi margin yang Anda dapatkan. Secara lebih lanjut dapat menghubungi <b>Bank, Perusahaan Pembiayaan atau Lembaga Penyalur Program Kredit Pemerintah tempat Anda memiliki kredit/pembiayaan</b>.</i></p>
                     <p><i>Namun, Anda dapat melaporkan apabila ditemui hal-hal yang tidak sesuai dengan aturan dan mengkoordinasikan hal tersebut dengan lembaga keuangan yang menyalurkan pembiayaan atau dapat menghubungi layanan call center <span class="text-danger">Hai DJPb 14090 atau melalui laman website</span> <a href="https://hai.kemenkeu.go.id" class="link-call" target="_blank">https://hai.kemenkeu.go.id/</a></i></p>
                     </div>
                  </div>
               </div>
               <div class="card mb-2">
                  <div class="card-header" id="headin-3">
                     <h2 class="mb-0">
                     <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse-3" aria-expanded="false" aria-controls="collapse-3">
                        3.	Dalam bentuk apakah konfirmasi penerimaan bantuan yang diterima? Apakah melalui SMS?
                     <span class="icon-trigger float-right"><i class="fa fa-chevron-down"></i></span>
                     </button>
                     </h2>
                  </div>

                  <div id="collapse-3" class="collapse" aria-labelledby="headin-3" data-parent="#accordion-faq">
                     <div class="card-body">
                     <i>Kanal informasi yang digunakan oleh Penyalur Kredit/Pembiayaan Anda bisa beragam seperti telepon, pesan singkat (SMS) maupun pesan melalui aplikasi whatsapp. Namun satu hal yang Anda harus waspadai adalah terkait dengan pesan palsu yang meminta Anda untuk melakukan transfer uang sebagai kompensasi atas program ini. Waspadai penipuan dan selalu berkoordinasi dengan pihak Penyalur Kredit/Pembiayaan jika Anda merasa ragu.</i>
                     </div>
                  </div>
               </div>
               <div class="card mb-2">
                  <div class="card-header" id="headin-4">
                     <h2 class="mb-0">
                     <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse-4" aria-expanded="false" aria-controls="collapse-4">
                        4.	Jika Pelaku Usaha menemukan perbedaan data di halaman cek subsidi, apakah yang harus dilakukan?
                     <span class="icon-trigger float-right"><i class="fa fa-chevron-down"></i></span>
                     </button>
                     </h2>
                  </div>

                  <div id="collapse-4" class="collapse" aria-labelledby="headin-4" data-parent="#accordion-faq">
                     <div class="card-body">
                     <i>Anda dapat berkoordinasi dengan Penyalur Kredit/Pembiayaan Anda untuk mendapatkan keterangan lebih lanjut.</i>
                     </div>
                  </div>
               </div>
               <div class="card mb-2">
                  <div class="card-header" id="headin-5">
                     <h2 class="mb-0">
                     <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse-5" aria-expanded="false" aria-controls="collapse-5">
                        5.	Jika pinjaman Pelaku Usaha beratasnamakan badan usaha, siapakah yang dapat melakukan pengecekkan?
                     <span class="icon-trigger float-right"><i class="fa fa-chevron-down"></i></span>
                     </button>
                     </h2>
                  </div>

                  <div id="collapse-5" class="collapse" aria-labelledby="headin-5" data-parent="#accordion-faq">
                     <div class="card-body">
                     <i>Yang dapat mewakili adalah pihak yang ditunjuk oleh pihak badan usaha tersebut. Pihak ini memiliki kewenangan untuk bertindak untuk dan atas nama badan usaha dimaksud.</i>
                     </div>
                  </div>
               </div>
               <div class="card mb-2">
                  <div class="card-header" id="headin-6">
                     <h2 class="mb-0">
                     <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse-6" aria-expanded="false" aria-controls="collapse-6">
                        6.	Apakah kategori performing loan lancar itu? Bagaimana saya mengetahui status performing loan pinjaman saya?
                     <span class="icon-trigger float-right"><i class="fa fa-chevron-down"></i></span>
                     </button>
                     </h2>
                  </div>

                  <div id="collapse-6" class="collapse" aria-labelledby="headin-6" data-parent="#accordion-faq">
                     <div class="card-body">
                     <i>Syarat untuk mendapatkan subsidi bunga/subsidi margin pada program ini adalah pinjaman dalam berada dalam status kol 1 atau kol 2. Secara umum, kol 1 adalah pinjaman yang berstatus lancar tanpa ada tunggakan dan kol 2 adalah pinjaman Dalam Perhatian Khusus (DPK) karena terjadi tunggakan 1-2 bulan. Jika Anda tidak yakin dengan status performing loan Anda, dapat dikonsultasikan secara langsung ke Bank, Perusahaan Pembiayaan atau Lembaga Penyalur Program Kredit Pemerintah tempat Anda memiliki kredit/pembiayaan.</i>
                     </div>
                  </div>
               </div>
               <div class="card mb-2">
                  <div class="card-header" id="headin-7">
                     <h2 class="mb-0">
                     <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse-7" aria-expanded="false" aria-controls="collapse-7">
                        7.	Bagaimana jika Pinjaman Pelaku Usaha ada yang tidak keluar pada halaman daftar subsidi?
                     <span class="icon-trigger float-right"><i class="fa fa-chevron-down"></i></span>
                     </button>
                     </h2>
                  </div>

                  <div id="collapse-7" class="collapse" aria-labelledby="headin-7" data-parent="#accordion-faq">
                     <div class="card-body">
                     <i>Debitur dapat melakukan konfirmasi dengan Penyalur terkait mengenai status pinjaman yang tidak muncul tersebut.</i>
                     </div>
                  </div>
               </div>
               <div class="card mb-2">
                  <div class="card-header" id="headin-8">
                     <h2 class="mb-0">
                     <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse-8" aria-expanded="false" aria-controls="collapse-8">
                        8.	Apakah Pelaku Usaha dapat mengganti pinjaman yang mendapat subsidi bunga/subsidi margin pinjaman?
                     <span class="icon-trigger float-right"><i class="fa fa-chevron-down"></i></span>
                     </button>
                     </h2>
                  </div>

                  <div id="collapse-8" class="collapse" aria-labelledby="headin-8" data-parent="#accordion-faq">
                     <div class="card-body">
                     <i>Tidak, secara otomatis sistem akan memilihkan pinjaman dengan benefit terbesar untuk Anda sesuai dengan data baki debet pinjaman yang disampaikan oleh OJK ke Kementerian Keuangan.</i>
                     </div>
                  </div>
               </div>
               <div class="card mb-2">
                  <div class="card-header" id="headin-9">
                     <h2 class="mb-0">
                     <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse-9" aria-expanded="false" aria-controls="collapse-9">
                        9.	Kemanakah saya dapat bertanya terkait dengan informasi lebih lanjut mengenai program subsidi bunga/subsidi margin ini?
                     <span class="icon-trigger float-right"><i class="fa fa-chevron-down"></i></span>
                     </button>
                     </h2>
                  </div>

                  <div id="collapse-9" class="collapse" aria-labelledby="headin-9" data-parent="#accordion-faq">
                     <div class="card-body">
                     <p><i>Untuk informasi teknis terkait dengan kredit/pembiayaan Anda, dapat ditanyakan secara langsung kepada Bank, Perusahaan Pembiayaan atau Lembaga Penyalur Program Kredit Pemerintah tempat Anda memiliki kredit/pembiayaan.</i></p>
                     <p><i>Sementara jika Anda memiliki pertanyaan lebih lanjut terkait program secara umum, Anda dapat menghubungi layanan call center <span class="text-danger">Hai DJPb 14090 atau melalui laman website</span> <a href="https://hai.kemenkeu.go.id/" class="link-call" target="_blank">https://hai.kemenkeu.go.id/</a>
                     </i></p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         
         <p class="last-updated"><span class="text-style-1">Terakhir diperbarui:</span> 7 Juli 2020</p>
      </div>
   </div>
      
    </div>
  </div>
</template>

<style>
#accordion-faq .card-header .btn-link[data-toggle="collapse"] {
   position: relative;
   padding-right: 15px ;
}

#accordion-faq .icon-trigger {
   position: absolute;
   top: 8px;
   right: 0px;
}
</style>

<script>
// @ is an alias to /src
import Highlight from '@/components/Highlight.vue'
import EventTracking from '../services/eventTracking'

export default {
  name: 'Home',
  components: {
    Highlight,
  },
  mixins: [EventTracking]
};
</script>
